module.exports = __webpack_public_path__ + "static/media/icon_checkbox_off.e480c221.svg";